// This file was generated using `pay js:run gql-v1 --type=fragment --name=LegalEntityJapanAddressArk --dir=path/to/dir`.
// To generate yours, do not copy and paste; use the command above instead. Do not delete this comment.

/* eslint-disable @stripe-internal/data-v1/camel-case-alias */

import {gql} from '@sail/data';

import type {GraphQlDocument} from '@sail/data';
import type {Exact} from '@stripe-internal/data-v1/schema/types';

import type {V1PermissionToken} from '@stripe-internal/data-v1/types';

const doc = gql`
  fragment LegalEntityJapanAddressArkFragment on OpenapiLegalEntityJapanAddress {
    city
    country
    db_code
    line1
    line2
    postal_code
    state
    town
  }
`;

export const legalEntityJapanAddressArkFragment: LegalEntityJapanAddressArkFragmentDocument =
  doc;

// THIS IS AUTOGENERATED CODE, DO NOT EDIT AS YOUR CHANGES WILL BE BLOWN AWAY
// Regenerate it using eslint in fix mode.

export type LegalEntityJapanAddressArkFragmentData = {
  readonly __typename: 'OpenapiLegalEntityJapanAddress';
  readonly city: string | null;
  readonly country: string | null;
  readonly db_code: string | null;
  readonly line1: string | null;
  readonly line2: string | null;
  readonly postal_code: string | null;
  readonly state: string | null;
  readonly town: string | null;
};

export type LegalEntityJapanAddressArkFragmentVariables = Exact<{
  [key: string]: never;
}>;

const legalEntityJapanAddressArkFragmentPermissions = {} as const;

doc.permissions = legalEntityJapanAddressArkFragmentPermissions;

export type LegalEntityJapanAddressArkFragmentPermissions = V1PermissionToken<
  typeof legalEntityJapanAddressArkFragmentPermissions
>;

export type LegalEntityJapanAddressArkFragmentDocument = GraphQlDocument<
  LegalEntityJapanAddressArkFragmentData,
  LegalEntityJapanAddressArkFragmentVariables,
  LegalEntityJapanAddressArkFragmentPermissions
>;
